var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import qs from 'qs';
import { isAndroid, isChangba, isIOS, isMars, isMarsProject, ua } from './config';
/**
 * 获取查询字符串的值
 * @param name 指定键
 * @param url 指定从某个字符串上获取查询字符串
 * @returns
 */
export function getQuery(name, url) {
    name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
    if (!url) {
        url = window.location.href;
    }
    var _regexS = '[\\?&]' + name + '=([^&#]*)';
    var _regex = new RegExp(_regexS);
    var _results = _regex.exec(url);
    return polyfillQuote(_results == null ? '' : decodeURIComponent(_results[1].replace(/\+/g, ' ')));
}
export function getUserId() {
    var userId = getQuery('curuserid') || getQuery('uuid') || getQuery('curuser');
    // 如果是火星业务线，并且活动跑在唱吧里，需要对userid追加7E
    var tmpUserId = Number.parseInt(userId, 10);
    // 有种可能，奥特曼配置的火星活动，不是mars.changba.com开头，在开发组件的时候也需要定义MARS变量
    if (isChangba && isMarsProject && !Number.isNaN(tmpUserId) && tmpUserId < 700000000) {
        tmpUserId += 700000000;
    }
    return Number.isNaN(tmpUserId) ? '' : String(tmpUserId);
}
export function getAppVersion(platform) {
    // 获取APP版本号，获取格式为 changeba/8.4.0
    var str = platform + '\\/([\\d\\.\\w]+)';
    var regex = new RegExp(str, 'i');
    var results = ua.match(regex);
    var cbVersion = Array.isArray(results) && results.length >= 2 ? results[1] : null;
    return cbVersion;
}
/**
 * 比较版本号，若v1大于v2，返回1，否则返回-1，相同返回0
 * @param v1 待比较的版本号1
 * @param v2 待比较的版本号2，默认取的是当前运行的app的版本号
 * @returns
 */
export function compareVersion(v1, v2) {
    if (!v2) {
        // 根据运行时判断
        v2 = getAppVersion(isMars ? 'easylive' : 'changba');
    }
    var v1array = v1.split('.') || [];
    var v2array = v2.split('.') || [];
    // 第次比较大版本号
    for (var i = 0; i < v1array.length && i < v2array.length; i++) {
        if (Number(v1array[i]) < Number(v2array[i])) {
            return -1;
        }
        if (Number(v1array[i]) > Number(v2array[i])) {
            return 1;
        }
    }
    // 主要版本号一致，版本号更长的更新，一致则为同一版本
    return v1array.length - v2array.length;
}
function getRandom(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    // 含最大值，含最小值
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function getGlobalParamsForIOS() {
    return new Promise(function (resolve) {
        var _a, _b;
        var callbackName = '__webkitChangbaCallerGetDefaultParams' + String(new Date().getTime()) + String(getRandom(1000, 9999));
        window[callbackName] = function (result) {
            try {
                resolve(JSON.parse(result));
            }
            catch (e) {
                resolve({});
            }
            ;
            window[callbackName] = null;
        };
        if ((_b = (_a = window.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.getDefaultParams) {
            window.webkit.messageHandlers.getDefaultParams.postMessage(callbackName);
        }
        else {
            resolve({});
        }
    });
}
/**
 * 兜底userid和token上面的引号
 * @param val
 * @returns
 */
function polyfillQuote(val) {
    var parsedResult;
    try {
        parsedResult = JSON.parse(val);
    }
    catch (exp) {
        parsedResult = val;
    }
    return parsedResult;
}
function getGlobalParamsForAndroid() {
    var _a, _b, _c;
    var result = (_c = (_b = (_a = window.changbaCaller) === null || _a === void 0 ? void 0 : _a.getDefaultParams) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : '{}';
    try {
        var parsedResult_1 = JSON.parse(result);
        // 强制兜底在安卓环境解析到的userId和token可能有问题的历史问题
        var userId1 = polyfillQuote(parsedResult_1.userId);
        var userId2 = polyfillQuote(parsedResult_1.userid);
        var userId3 = polyfillQuote(parsedResult_1.curuserid);
        parsedResult_1.userId = String(userId1 || userId2 || userId3);
        parsedResult_1.roomid = polyfillQuote(parsedResult_1.roomid) || polyfillQuote(parsedResult_1.roomId);
        parsedResult_1.roomId = parsedResult_1.roomid;
        var needParsedKeys = ['token', 'channelsrc', 'systemversion', 'os', 'version', 'latitude', 'longitude'];
        needParsedKeys.forEach(function (key) {
            parsedResult_1[key] = polyfillQuote(parsedResult_1[key]);
        });
        return parsedResult_1;
    }
    catch (e) {
        return {};
    }
}
// 各种兼容性处理
function compatibility(params) {
    if (!params.macaddress && params.n4) {
        // 新版本没有 macaddress 使用 n4 代替
        params.macaddress = params.n4;
    }
    else if (params.macaddress && !params.n4) {
        // 旧版本没有 n4 使用 macaddress 代替
        params.n4 = params.macaddress;
    }
    else if (!params.macaddress && !params.n4) {
        var macAddress = getQuery('macaddress');
        var deviceId = getQuery('deviceid');
        var n4 = getQuery('global_params_n4');
        params.n4 = n4 || macAddress || deviceId;
        params.macaddress = params.n4;
    }
    if (!params.userId) {
        params.userId = getUserId();
    }
    if (!params.roomid) {
        params.roomid = getQuery('room_id') || getQuery('roomid') || getQuery('roomId');
        params.roomId = params.roomid;
    }
    if (!params.token) {
        params.token = getQuery('token');
    }
    if (!params.appVersion) {
        var match = /\s+changba\/([\d.]+)/.exec(ua);
        if (match) {
            params.appVersion = match[1];
        }
    }
    if (!params.smdeviceid) {
        params.smdeviceid = getQuery('shuMeiId');
    }
    if (!params.longitude) {
        params.longitude = getQuery('longitude');
    }
    if (!params.latitude) {
        params.latitude = getQuery('latitude');
    }
    params.smDeviceId = params.smdeviceid;
    params.deviceId = params.n4 || params.uuid;
    return params;
}
/**
 * 获取全局参数
 * @returns
 */
export function getGlobalParams() {
    return new Promise(function (resolve) {
        if (isChangba) {
            if (isAndroid) {
                resolve(compatibility(getGlobalParamsForAndroid()));
                return;
            }
            if (isIOS) {
                getGlobalParamsForIOS().then(function (result) {
                    resolve(compatibility(result));
                });
                return;
            }
        }
        resolve(compatibility({}));
    });
}
/**
 * 提取url上的已存在参数
 * @param inputParams.url 从什么地址上提取
 * @param inputParams.params 追加参数
 * @param inputParams.omitParams 忽略参数
 */
export function extractExistUrlParams(inputParams) {
    if (inputParams === void 0) { inputParams = {}; }
    var _a = inputParams.url, url = _a === void 0 ? window.location.href : _a, _b = inputParams.params, params = _b === void 0 ? {} : _b, _c = inputParams.omitParams, omitParams = _c === void 0 ? [] : _c;
    // 找到问号出现的位置
    var quesIdx = url.indexOf('?');
    // 读取到查询字符串
    var queryString = quesIdx < 0 ? '' : url.slice(quesIdx + 1);
    var paredParams = __assign(__assign({}, qs.parse(queryString)), params);
    // 删除不需要的参数
    omitParams.forEach(function (prop) {
        delete paredParams[prop];
    });
    return qs.stringify(paredParams);
}
